import {
  ColumnActionsMode,
  IColumn,
  IDetailsColumnStyles,
} from '@fluentui/react';
import { rightAlignHeaderStyle } from 'common/utils/columnUtilities';

const commonProps: Partial<IColumn> = {
  isResizable: true,
  columnActionsMode: ColumnActionsMode.disabled,
};

export const columns: IColumn[] = [
  {
    key: 'requesterName',
    name: 'Name',
    fieldName: 'requesterName',
    minWidth: 120,
    maxWidth: 180,
    ...commonProps,
  },
  {
    key: 'requestedDate',
    name: 'Date Requested',
    fieldName: 'requestedDate',
    minWidth: 150,
    maxWidth: 170,
    styles: rightAlignHeaderStyle,
    ...commonProps,
  },
  {
    key: 'statusType',
    name: 'Status',
    fieldName: 'statusType.statusType',
    minWidth: 80,
    maxWidth: 100,
    ...commonProps,
    styles: rightAlignHeaderStyle,
  },
  {
    key: 'viewHierarchy',
    name: '',
    fieldName: 'viewHierarchy',
    minWidth: 40,
    maxWidth: 40,
    ...commonProps,
  },
];
